import { render, staticRenderFns } from "./BaseSearchBar.vue?vue&type=template&id=52394691&"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js&"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports